import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';

/**
 * Fetches the seller's online status.
 * @param {object} pathfinderWrapper the context's pathfinder wrapper.
 * @param {object} logger the context's logger.
 * @returns {boolean} whether or not the user is online.
 */
const fetchIsOnline = async({ pathfinderWrapper, logger }) => {
    const { pathParameters } = getContext();
    const { username } = pathParameters;
    const url = pathfinderWrapper.pathfinder('is_online', { username });

    try {
        const { data } = await axios.get(url);
        const { is_online: isOnline = false } = data;

        return isOnline;
    } catch (error) {
        logger.error(error, {
            description: 'Failed to fetch seller online status'
        });

        return false;
    }
};

export default fetchIsOnline;
